import { render, staticRenderFns } from "./VolvoXC40RechargePlanDisclosure2023.vue?vue&type=template&id=f1e89962&"
import script from "./VolvoXC40RechargePlanDisclosure2023.vue?vue&type=script&lang=js&"
export * from "./VolvoXC40RechargePlanDisclosure2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports